export enum EntityOwnershipType {
    Principal = 1,
    Entity = 2,
    PeopleGroup = 3,
}
